// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  UserMaxPrice,
} from "./types";

export default {
  underwritableEntityId: __t.uuid(),
  targetablePropertyId: __t.uuid(),
  get userMaxPrice() {
    return UserMaxPrice;
  },
};
